import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut, ScrollText, AlertOctagon, MessageCircle, Crown } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { DashboardShell } from "../../components/shared/DashboardShell";
import { LoadingState } from "../../components/shared/EmptyState";
import { adminNav } from "../../components/shared/navConfig";
import { useAuth } from "../../context/AppContext";
import { useApi } from "../../lib/useApi";

export default function AdminSettings() {
  const { data, loading } = useApi("/admin/settings");
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const signOutAll = async () => {
    await api.post("/auth/logout-all");
    localStorage.removeItem("session_token");
    setUser(null); toast.success("Signed out on all devices"); navigate("/auth");
  };
  return (
    <DashboardShell nav={adminNav} title="Settings" subtitle="Account, security and admin tools">
      {loading ? <LoadingState/> : (
        <div className="grid lg:grid-cols-2 gap-5">
          <div className="card-surface p-5">
            <div className="eyebrow mb-3">Your account</div>
            <div className="flex items-center gap-2 mb-1"><span data-testid="settings-email" className="text-sm" style={{ color: "var(--text)" }}>{data?.me?.email}</span>
              {data?.me?.is_superadmin && <span data-testid="settings-superadmin-badge" className="chip text-amber-500 inline-flex items-center gap-1"><Crown size={11}/> Superadmin</span>}</div>
            <div className="text-xs mb-4" style={{ color: "var(--text-dim)" }}>{data?.active_sessions} active session(s)</div>
            <button data-testid="settings-logout-all-btn" onClick={signOutAll} className="btn-ghost px-4 py-2.5 rounded-full text-xs inline-flex items-center gap-1.5"><LogOut size={13}/> Sign out on all devices</button>
          </div>
          <div className="card-surface p-5">
            <div className="eyebrow mb-3">Admin accounts</div>
            {(data?.admins || []).map(a => (
              <div key={a.email} data-testid={`settings-admin-${a.email}`} className="flex items-center justify-between py-2 border-b last:border-b-0 text-sm" style={{ borderColor: "var(--border)" }}>
                <span className="truncate" style={{ color: "var(--text)" }}>{a.email}</span>
                <span className="text-xs inline-flex items-center gap-1" style={{ color: "var(--text-dim)" }}><ShieldCheck size={12}/>{a.is_superadmin ? "Superadmin" : "Admin"}</span>
              </div>
            ))}
          </div>
          <div className="card-surface p-5 lg:col-span-2">
            <div className="eyebrow mb-3">Tools</div>
            <div className="grid sm:grid-cols-3 gap-2">
              <Link to="/admin/audit" data-testid="settings-audit-link" className="btn-ghost px-4 py-3 rounded-lg text-sm inline-flex items-center gap-2"><ScrollText size={14}/> Audit log</Link>
              <Link to="/admin/disputes" data-testid="settings-disputes-link" className="btn-ghost px-4 py-3 rounded-lg text-sm inline-flex items-center gap-2"><AlertOctagon size={14}/> Disputes</Link>
              <Link to="/admin/whatsapp" data-testid="settings-whatsapp-link" className="btn-ghost px-4 py-3 rounded-lg text-sm inline-flex items-center gap-2"><MessageCircle size={14}/> WhatsApp Center</Link>
            </div>
            <p className="text-xs mt-4" style={{ color: "var(--text-dim)" }}>Customer support WhatsApp: +91 84840 48673</p>
          </div>
        </div>
      )}
    </DashboardShell>
  );
}
